"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var GridItemPrice_1 = require("../../prices/gridItemPrice/GridItemPrice");
var CarOptions_1 = require("../../carOptions/CarOptions");
var DiscountList_1 = require("../../discountList/DiscountList");
var VehicleOptionsTaxes_1 = require("./vehicleOptionsTaxes/VehicleOptionsTaxes");
var Emissions_1 = require("./emissions/Emissions");
var VehicleDetailsDisclaimer_1 = require("./vehicleDetailsDisclaimer/VehicleDetailsDisclaimer");
var ReservationDetail_1 = require("../../prices/reservation/ReservationDetail");
var ExpressionsOfInterest_1 = require("./expressionsOfInterest/ExpressionsOfInterest");
var VehicleOptionsSummary = function (_a) {
    var _b;
    var totalPrice = _a.totalPrice, taxes = _a.taxes, totalAmountPayable = _a.totalAmountPayable, isMultiCurrency = _a.isMultiCurrency, mappedOptions = _a.mappedOptions, optionsTotal = _a.optionsTotal, displayCurrency = _a.displayCurrency, discounts = _a.discounts, style = _a.style, hideTotalPrice = _a.hideTotalPrice, coTwo = _a.coTwo, range = _a.range, taxLabel = _a.taxLabel, hideReservationDetails = _a.hideReservationDetails, hideDriveawayPrice = _a.hideDriveawayPrice, expressionsOfInterest = _a.expressionsOfInterest;
    var _c, _d, _e, _f;
    var hasDiscounts = (_c = discounts) === null || _c === void 0 ? void 0 : _c.length;
    var _g = core_1.useTheme().checkoutLite, hideAddCarDetails = _g.confirmation.hideAddCarDetails, showTaxes = _g.summary.showTaxes;
    return (<>
      <core_1.Grid item={true} className={clsx_1.default(style.totalPrice, (_b = {},
        _b[style.withoutOptions] = ((_d = mappedOptions()) === null || _d === void 0 ? void 0 : _d.length) < 1,
        _b))}>
        {!hideTotalPrice && (<GridItemPrice_1.default price={totalPrice} className={{
        price: style.price,
        label: style.label,
    }} currency={displayCurrency} dataTest="summary:car_details:total_primary" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__total_label'} taxLabel={taxLabel}/>)}
        {((_e = mappedOptions()) === null || _e === void 0 ? void 0 : _e.length) > 0 && !hideAddCarDetails && (<CarOptions_1.default mappedOptions={mappedOptions} displayCurrency={displayCurrency} optionsTotal={optionsTotal} taxLabel={taxLabel} totalPriceTax={(_f = taxes) === null || _f === void 0 ? void 0 : _f.gvt}/>)}
      </core_1.Grid>
      {showTaxes && (<VehicleOptionsTaxes_1.default taxes={taxes} isMultiCurrency={isMultiCurrency} displayCurrency={displayCurrency}/>)}
      {!!hasDiscounts && <DiscountList_1.default currency={displayCurrency} discounts={discounts}/>}
      {!hideDriveawayPrice && (<core_1.Grid item={true} className={style.totalAmountPayable}>
          <GridItemPrice_1.default price={totalAmountPayable} className={{
        price: style.price,
        label: style.label,
    }} currency={displayCurrency} dataTest="summary:car_details:total_payable" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__total_price_label'} taxLabel={taxLabel}/>
        </core_1.Grid>)}
      
      {!hideReservationDetails && <ReservationDetail_1.default totalAmount={totalAmountPayable} currency={displayCurrency}/>}
      <Emissions_1.default coTwo={coTwo} range={range}/>
      <ExpressionsOfInterest_1.default expressionsOfInterest={expressionsOfInterest}/>
      <VehicleDetailsDisclaimer_1.default />
    </>);
};
exports.default = VehicleOptionsSummary;
